<template lang="pug">
  b-container(fluid)
    b-card.shadow.mt-2(v-if="response_blocks && response_blocks.length")
      response-block(v-for="response in response_blocks", :key="response.response_id", v-bind="response")
    hr
    b-card.shadow
      h5 Automatización en asignación sin éxito
      p.text-secondary La conversación se redirigirá al bloque de flujo especificado automáticamente después de un intento de asignación de caso. ("Agentes no disponibles durante asignación" y "Agentes ocupados durante asignación")
      b-form-checkbox(switch,v-model="account_config.smart_automation" size="lg") {{account_config.smart_automation ? 'Activado' : 'Desactivado'}}
      b-form-group(label="Selecciona el bloque", v-if="account_config.smart_automation")
        block-connector(:next_block_id="account_config.automation_block_id", @change="data => {account_config.automation_block_id = data.next_block_id}")
        b-link.text-danger.text-sm(@click="account_config.automation_block_id = null") Borrar bloque
    hr
    b-card.shadow
      h5 Enviar a bloque al cerrar un caso
      p.text-secondary La conversación se redirigirá al bloque de flujo especificado automáticamente después de cerrar un caso.
      b-form-group(label="Bloque al cerrar caso")
        block-connector(:next_block_id="account_config.close_case_next_block_id", @change="data => {account_config.close_case_next_block_id = data.next_block_id}")
        b-link.text-danger.text-sm(@click="account_config.close_case_next_block_id = null") Borrar bloque
    hr
    b-card.shadow
      h5 Tipo de mensaje por QR (WhatsApp)
      b-form-group(label="Tipo de mensaje")
        b-form-select(v-model="account_config_v2.qrType")
          option(disabled) --Selecciona opción--
          option(value="uuid") UUID
          option(value="adminName") Nombre del agente
    hr(v-if="account_config_v2.qrType === 'adminName'")
    b-card.shadow(v-if="account_config_v2.qrType === 'adminName'")
      h5 Mensaje de bienvenida para QR
      p.text-secondary Configura el mensaje que se enviará al escanear un código QR. (Solo para WhatsApp)
      p.text-secondary Puedes usar las variables {first_name}, {last_name}
      b-form-group(label="Mensaje")
        b-form-textarea(placeholder="Mensaje", rows="3", v-model="account_config_v2.customQrMessage", trim)
    hr
    b-card.shadow
      h5 Enviar "screen-name" del agente en cada mensaje
      b-row
        b-col
          b-form-group(label="WhatsApp")
            b-form-checkbox.mb-3(switch, v-model="account_config.is_whatsapp_screen_name_enabled", size="lg") {{account_config.is_whatsapp_screen_name_enabled ? 'Activado' : 'Desactivado'}}
        b-col
          b-form-group(label="BMessaging")
            b-form-checkbox.mb-3(switch, v-model="account_config.is_bmessaging_screen_name_enabled", size="lg") {{account_config.is_bmessaging_screen_name_enabled ? 'Activado' : 'Desactivado'}}
    hr
    b-card.shadow
      h5 Numero máximo de casos asignados a un administrador
      number-input(v-model.number="account_config.max_cases_to_assign", controls, inline, center, placeholder="0", :min="0")
    hr
    b-card.shadow
      h5 Ciclo de atención de casos
      p.text-secondary Configuración para realizar acciones sobre los casos que están abiertos o en espera y no han sido atendidos.
      b-form-row.mb-4
        b-col.mb-3(cols="12")
          b-form-group(label="Tiempo de espera para realizar acción de emergencia a un caso desatendido. (Tiempo mínimo 3 min.)")
            b-form-row
              b-col(cols="auto")
                b-form-group(label="Horas", label-size="sm")
                  number-input(v-model="hours", size="small", controls, inline, center, placeholder="0", :min="0", @change="timeToFloat")
              b-col(cols="auto")
                b-form-group(label="Minutos", label-size="sm")
                  number-input(v-model="minutes", size="small", controls, inline, center, placeholder="0", :min="3", :max="59", @change="timeToFloat")
        b-col(cols="12")
          b-form-group(label="Número de reasignaciones de administradores antes de ejecutar acción de emergencia", description="Si el valor es cero, se ejecutará directamente la acción de emergencia")
            number-input.text-center(v-model="account_config.case_assignment_times", controls, inline, center, placeholder="0", :min="0")
      b-form-group(label="Acción de emergencia")
        b-form-select(v-model="account_config.case_emergency_action")
          option(disabled) --Selecciona opción--
          option(v-for="action in emergency_actions", :key="action.value", :value="action.value") {{action.title}}
      b-card.mb-0.bg-light(v-if="emergency_action")
        b-form-group(v-if="emergency_action === 'send_text'", label="Mensaje a enviar")
          b-form-textarea.mb-2(placeholder="Mensaje", rows="3", v-model="account_config.emergency_text", trim, :state="account_config.emergency_text ? null : (validated ? false : null)")
        b-form-group(v-if="emergency_action === 'admin_assign'", label="Administradores de emergencia", :description="emergency_admins.length > 1 ? 'La asignación del caso será de manera aleatoria' : ''")
          v-select.bg-light-white(:placeholder="!parsedAdmins.length ? 'No hay admins disponibles' : 'Buscar por nombre o correo'", :disabled="Boolean(!parsedAdmins.length)", :multiple="true", :options="parsedAdmins.map(a => a.value)", :clearable="true", label="title", :value="emergency_admins", @input="setAdmins", :filterBy="filterAdminBy", @search:focus="getAdmins")
            template(slot="spinner", v-if="loading_admins")
              b-spinner.ml-2(small, variant="primary")
        b-form-group(v-else-if="emergency_action === 'group_assign'", label="Grupo de emergencia", description="El caso se asignará a un agente en estado disponible dentro de este grupo")
          b-form-select(v-model="account_config.emergency_group")
            option(:value="null", disabled) --Selecciona grupo--
            option(v-for="group in groups", :key="group.group_id", :value="group.group_id") {{group.name}}
        b-form-group(v-else-if="emergency_action === 'send_email'", label="Correo de emergencia")
          v-select.bg-light-white(:placeholder="!parsedAdmins.length ? 'No hay admins disponibles' : 'Buscar por nombre o correo'", :disabled="Boolean(!parsedAdmins.length)", :multiple="false", :options="parsedAdmins.map(a => a.value)", :clearable="true", label="title", :value="emergency_admins", @input="account_config.emergency_admin = $event.admin_id.toString()", :filterBy="filterAdminBy", @search:focus="getAdmins")
            template(slot="spinner", v-if="loading_admins")
              b-spinner.ml-2(small, variant="primary")
        b-form-group(v-else-if="emergency_action === 'send_sms'", label="Números donde mandar mensaje SMS", invalid-feedback="Ingresa solo los números del teléfono")
          b-form-tags(:value="account_config.emergency_sms ? account_config.emergency_sms.split(',') : []", @input="account_config.emergency_sms = $event.join(',')", placeholder="Escribe los números clave separadas por coma", remove-on-delete, tag-variant="soft-primary", add-button-text="Agregar", duplicate-tag-text="Etiquetas duplicadas", separator=" ,", :state="valid_numbers")
        b-form-group(v-else-if="emergency_action === 'close_case'", label="Bloque al cerrar caso", description="La conversación se redirigirá al bloque de flujo establecido cuando se cierra un caso.")
          block-connector(:next_block_id="account_config.close_case_next_block_id", @change="data => {account_config.close_case_next_block_id = data.next_block_id}")
          b-link.text-danger(v-if="account_config.close_case_next_block_id", @click="account_config.close_case_next_block_id = null") Quitar conexión
        b-form-group(v-else-if="emergency_action === 'next_block'", label="Bloque de emergencia", description="La conversación se redirigirá al bloque seleccionado.")
          block-connector(:next_block_id="account_config.emergency_next_block_id", @change="data => {account_config.emergency_next_block_id = data.next_block_id}")
          b-link.text-danger(v-if="account_config.emergency_next_block_id", @click="account_config.emergency_next_block_id = null") Quitar conexión
    hr
    b-form-group
      span(v-b-toggle.clickMe) Ajustes avanzados
      chevron-down-icon.ml-1.icon-md.collapse-chevron-icon(v-b-toggle.clickMe)
      b-collapse.my-2(id='clickMe')
        hr
        b-card.shadow
          h5 Moneda por defecto (para usar en e-commerce)
          b-form-group
            b-form-select(v-model="currency", :options="currencies", @change="putCurrency()")
        hr
        b-card.shadow
          h5 Agregar etiquetas al cerrar casos
          b-form-group
            b-form-checkbox.mb-3(switch, v-model="account_config.force_case_tag", size="lg") {{account_config.force_case_tag ? 'Activado' : 'Desactivado'}}
        hr
        b-card.shadow
          h5 Aprendizaje automático
          b-form-group
            template(slot="label")
              p.text-secondary Configura las respuestas del bot de acuerdo al conocimiento aprendido automáticamente. Recuerda que primero debes validar el conocimiento desde la vista de
                b-link.ml-1(:to="{name: 'Learning', params: { account_id: $route.params.account_id } }") Aprendizaje.
              p.mb-0 Usar respuestas autogeneradas
            b-form-checkbox.mb-3(switch, v-model="account_config.graph_nlp_enabled", size="lg") {{account_config.graph_nlp_enabled ? 'Activado' : 'Desactivado'}}
        hr
        b-card.shadow
          h5 Tipo de asignación
          b-form-group
            b-form-select(v-model="assignmentType", :options="assignmentTypes", @change="putAssignmentType()")
        hr
        b-card.shadow
          h5 Tipo de ordenamiento durante asignación
          b-form-group
            b-form-select(v-model="sortType", :options="sortTypes", @change="putSortType()")
        hr

    b-button(variant="primary", block, @click="updateConfiguration", :disabled="loading")
      span Guardar
      b-spinner.ml-2(small, type="grow", variant="light", v-if="loading")
</template>

<script>
import { ability } from '@/helpers/abilities'
import ResponseBlock from '../../components/ResponseBlock'
import { createNamespacedHelpers, mapActions } from 'vuex'

const accountController = createNamespacedHelpers('account')
const groupController = createNamespacedHelpers('group')
const responseBlockController = createNamespacedHelpers('response_block')

export default {
  data() {
    return {
      loading: false,
      loading_admins: false,
      validated: false,
      emergency_actions: [
        { title: 'No realizar ninguna acción', value: null },
        { title: 'Enviar mensaje', value: 'send_text' },
        { title: 'Conectar con un bloque', value: 'next_block' },
        { title: 'Asignar a un administrador', value: 'admin_assign' },
        { title: 'Asignar a administrador de un grupo', value: 'group_assign' },
        { title: 'Enviar correo electrónico', value: 'send_email' },
        // {title: 'Enviar SMS', value: 'send_sms'},
        { title: 'Cerrar caso', value: 'close_case' }
      ],
      hours: 0,
      minutes: 0,
      currency: null,
      currencies: [
        { text: '- Seleccionar moneda -', value: null, disabled: true },
        { text: 'Peso mexicano - MXN', value: 'MXN' },
        { text: 'Dolar americano - USD', value: 'USD' },
        { text: 'Dolar canadiense - CAD', value: 'CAD' },
        { text: 'Real brasileño - BRL', value: 'BRL' },
        { text: 'Sol peruano - PEN', value: 'PEN' },
        { text: 'Peso colombiano - COP', value: 'COP' },
        { text: 'Peso argentino - ARS', value: 'ARS' },
        { text: 'Peso chileno - CLP', value: 'CLP' },
        { text: 'Colón costarricense - CRC', value: 'CRC' },
        { text: 'Peso cubano - CUC', value: 'CUC' },
        { text: 'Quetzal - GTQ', value: 'GTQ' },
        { text: 'Gourde - HTG', value: 'HTG' },
        { text: 'Lempira - HNL', value: 'HNL' },
        { text: 'Córdoba - NIO', value: 'NIO' },
        { text: 'Guaraní - PYG', value: 'PYG' },
        { text: 'Boliviano - BOB', value: 'BOB' },
        { text: 'Peso dominicano - DOP', value: 'DOP' },
        { text: 'Peso uruguayo - UYU', value: 'UYU' },
        { text: 'Bolívar - Bs.', value: 'Bs.' }
      ],
      assignmentType: null,
      assignmentTypes: [
        {
          text: '- Selecciona tipo de asignación -',
          value: null,
          disabled: true
        },
        { text: 'A demanda', value: 'on_demand' },
        { text: 'Normal', value: 'per_agent' }
      ],
      sortType: null,
      sortTypes: [
        {
          text: '- Selecciona tipo de ordenamiento durante asignación -',
          value: null,
          disabled: true
        },
        { text: 'Por último caso asignado', value: 'last_case_assigned' },
        { text: 'Por número de casos abiertos', value: 'number_of_cases' }
      ]
    }
  },
  computed: {
    ...accountController.mapState({
      account_config: (state) => state.account_configuration,
      account_config_v2: (state) => state.account_configuration_v2,
      admins: (state) => state.admins
    }),
    ...groupController.mapState({
      groups: (state) => state.groups
    }),
    ...responseBlockController.mapState({
      response_blocks: (state) =>
        state.response_blocks.filter((el) => el.type === 'no_answer')
    }),
    emergency_action() {
      return this.account_config.case_emergency_action
    },
    parsedAdmins() {
      return this.admins.map((a) => {
        return {
          text: `${a.email}`,
          value: {
            title: `${a.first_name} ${a.last_name} (${a.email})`,
            email: `${a.email}`,
            admin_id: a.admin_id
          }
        }
      })
    },
    emergency_admins() {
      const admins = this.account_config.emergency_admin
        ? this.account_config.emergency_admin.split(',')
        : []
      return this.parsedAdmins
        .filter((a) => admins.includes(a.value.admin_id.toString()))
        .map((a) => a.value)
    },
    valid_numbers() {
      return this.account_config.emergency_sms
        ? this.account_config.emergency_sms.split(',').some((n) => isNaN(n))
          ? false
          : null
        : null
    }
  },
  methods: {
    ...mapActions([
      'account/admins',
      'group/all',
      'response_block/all',
      'account/get_configuration',
      'account/update_configuration',
      'account/get_configuration_v2',
      'account/update_configuration_v2'
    ]),
    putValues() {
      this.assignmentType = this.account_config.case_queue_type
      this.sortType = this.account_config.case_queue_sort
      this.currency = this.account_config.currency
    },
    getAdmins() {
      const self = this

      this.loading_admins = true

      this['account/admins']({
        account_id: self.$route.params.account_id,
        callback: (res) => {
          self.loading_admins = false
          if (res.error) {
            self.$message.error(res.error)
          }
        }
      })
    },
    getGroups() {
      const self = this

      this['group/all']({
        account_id: self.$route.params.account_id,
        callback: (res) => {
          if (res.error) {
            self.$message.error(res.error)
          }
        }
      })
    },
    getResponseBlocks() {
      const self = this

      this['response_block/all']({
        account_id: self.$route.params.account_id,
        callback: (res) => {
          if (res.error) {
            self.$message.error(res.error)
          }
        }
      })
    },
    getConfiguration() {
      if (!ability.can('read', 'account-configuration')) return

      this.loading = true

      this['account/get_configuration']({
        account_id: this.$route.params.account_id,
        callback: (res) => {
          this.loading = false

          if (res.error) return this.$message.error(res.error)

          this.floatToTime(this.account_config.case_time_out)
          this.putValues()
        }
      })
      this['account/get_configuration_v2']({
        account_id: this.$route.params.account_id,
        callback: (res) => {
          this.loading = false

          if (res.error) return this.$message.error(res.error)
        }
      })
    },
    putCurrency() {
      return (this.account_config.currency = this.currency)
    },
    putAssignmentType() {
      return (this.account_config.case_queue_type = this.assignmentType)
    },
    putSortType() {
      return (this.account_config.case_queue_sort = this.sortType)
    },
    updateConfiguration() {
      switch (this.emergency_action) {
        case 'send_text':
          if (!this.account_config.emergency_text) {
            this.validated = true
            return
          }
          break
      }
      // todo validate other action inputs

      this.loading = true
      const self = this

      this['account/update_configuration']({
        ...self.account_config,
        callback: (res) => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.$message.success('Configuración actualizada')
          }
        }
      })
      this['account/update_configuration_v2']({
        account_id: self.$route.params.account_id,
        ...self.account_config_v2,
        callback: (res) => {
          self.loading = false
          if (res.error) {
            return self.$message.error(res.error)
          }
          self.$message.success('Configuración actualizada')
        }
      })
    },
    filterAdminBy(option, label, search) {
      return (
        (option.title || '').toLowerCase().indexOf(search.toLowerCase()) > -1 ||
        (option.email || '').toLowerCase().indexOf(search.toLowerCase()) > -1
      )
    },
    setAdmins(event) {
      this.account_config.emergency_admin = event
        .map((a) => a.admin_id)
        .join(',')
    },
    floatToTime(value) {
      this.hours = Math.floor(value)
      const min = 1 / 60
      let remain = value - this.hours
      remain = min * Math.round(remain / min)
      this.minutes = Math.floor(remain * 60)
    },
    timeToFloat() {
      if (this.minutes < 3) this.minutes = 3

      const min = this.minutes / 60
      this.account_config.case_time_out = (this.hours + min).toFixed(2)
    },
    timeFormat(seconds) {
      if (seconds <= 60) {
        return 'Menos de 1 min'
      }

      let remain = seconds
      let time_format = ''

      const days = Math.floor(remain / (60 * 60 * 24))
      remain = remain % (60 * 60 * 24)

      const hours = Math.floor(remain / (60 * 60))
      remain = remain % (60 * 60)

      const minutes = Math.floor(remain / 60)
      // remain = remain % (60)

      time_format += days ? `${days} ${days != 1 ? 'días ' : 'día '}` : ''
      time_format += hours ? `${hours} hrs ` : ''
      time_format += `${minutes} min`
      // time_format += `, ${remain ? remain : '00'} sec}`
      return time_format
    }
  },
  mounted() {
    this.getAdmins()
    this.getGroups()
    this.getResponseBlocks()
    this.getConfiguration()
  },
  components: { ResponseBlock }
}
</script>

<style lang="scss" scoped></style>
